// extracted by mini-css-extract-plugin
module.exports = {"topBanner":"TopBanner-module--topBanner--1WPy0"};